import type { MarkerClusterOptions } from '@gpx-spa/geo-domain'
import { resolveMarkerClusterSettings } from '../shared/resolve-marker-cluster-settings.js'
import { createLeafletDonutClusterIconCreateFunction } from './leaflet-donut-cluster.js'

export function leafletMarkerClusterOptions(
  o: MarkerClusterOptions | undefined,
  extra?: { clusterPane?: string },
): {
  maxClusterRadius: number
  showCoverageOnHover: boolean
  disableClusteringAtZoom: number
  clusterPane?: string
  iconCreateFunction?: ReturnType<typeof createLeafletDonutClusterIconCreateFunction>
} {
  const settings = resolveMarkerClusterSettings(o)
  return {
    maxClusterRadius: settings.radius,
    showCoverageOnHover: settings.showCoverageOnHover,
    disableClusteringAtZoom: settings.maxZoom + 1,
    ...(extra?.clusterPane ? { clusterPane: extra.clusterPane } : {}),
    ...(settings.icon === 'donut'
      ? { iconCreateFunction: createLeafletDonutClusterIconCreateFunction() }
      : {}),
  }
}

export { resolveClusterConfig } from '../mapbox/mapbox-utils.js'
